import React, { useEffect } from 'react';
import './Modal.css';

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  size?: '55vh' | '80vh' | 'fullscreen';
  position?: 'bottom' | 'center';
  children: React.ReactNode;
  className?: string;
  showCloseButton?: boolean;
  closeOnOverlayClick?: boolean;
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  size = '55vh',
  position = 'bottom',
  children,
  className = '',
  showCloseButton = true,
  closeOnOverlayClick = true,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (closeOnOverlayClick) {
      onClose();
    }
  };

  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const overlayClasses = [
    'modal-overlay',
    position === 'center' ? 'modal-overlay--center' : '',
    className
  ].filter(Boolean).join(' ');

  const contentClasses = [
    'modal-content',
    `modal-content--${size}`,
    position === 'center' ? 'modal-content--center' : ''
  ].filter(Boolean).join(' ');

  return (
    <div className={overlayClasses} onClick={handleOverlayClick}>
      <div className={contentClasses} onClick={handleContentClick}>
        {title && (
          <div className="modal-content__header">
            <h2 className="modal-content__title">{title}</h2>
            {showCloseButton && (
              <button
                className="modal-content__close"
                onClick={onClose}
                aria-label="Закрыть"
              >
                ×
              </button>
            )}
          </div>
        )}
        <div className="modal-content__body">
          {children}
        </div>
      </div>
    </div>
  );
};
